import React, { PropsWithChildren, useEffect } from 'react'
import clsx from 'clsx'

import { check, getPanelRadioID } from './Wizard.helpers'
import ColorScheme from '../../common/types/ColorScheme'
import WizardContext from './WizardContext'
import WizardTimeline, { Step } from './WizardTimeline'
import WizardStep from './WizardStep'

import './Wizard.css'

export interface WizardProps {
  current: number | string
  id: number | string
  steps: Array<Step>
  className?: string
  scheme?: ColorScheme
}

// TODO: improve by extracting steps props right from children.
function Wizard({ id, children, className, current, steps }: PropsWithChildren<WizardProps>) {
  useEffect(() => {
    check(getPanelRadioID(current))
  }, [current])

  return (
    <section id={String(id)} className={clsx('rg-wizard w-full', className)}>
      <Wizard.Timeline current={current} steps={steps} />
      <WizardContext.Provider value={id}>{children}</WizardContext.Provider>
    </section>
  )
}

Wizard.defaultProps = {
  scheme: 'light',
}

Wizard.Step = WizardStep
Wizard.Timeline = WizardTimeline

export default Wizard
